// Environment configuration for BigSystemOne
export const config = {
  // API Configuration - Using microservices routing from apiRouting.ts
  API_BASE_URL: process.env.REACT_APP_API_URL || '',
  
  // AWS Cognito Configuration
  COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_Jw9kHxDre',
  COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '2sjuuubp9b9332tc6rf4p3t1fe',
  
  // AWS Region
  AWS_REGION: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  
  // Environment
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development',
  
  // AccuWeather API Configuration
  ACCUWEATHER_API_KEY: process.env.REACT_APP_ACCUWEATHER_API_KEY || '',
  ACCUWEATHER_BASE_URL: process.env.REACT_APP_ACCUWEATHER_BASE_URL || 'https://dataservice.accuweather.com',
  
  // Feature flags
  features: {
    enableRealTimeUpdates: process.env.NODE_ENV === 'production',
    enableAdvancedMetrics: process.env.NODE_ENV === 'production',
  }
};

export default config;